export class Tastetype {
	id: number;
	active: boolean;
	sort_order: number;
	
    name_nl: string;
    short_description_nl: string;
	description_nl: string;
	alias_nl: string;
	
    name_en: string;
    short_description_en: string;
	description_en: string;
	alias_en: string;
	
    name_fr: string;
    short_description_fr: string;
	description_fr: string;
	alias_fr: string;
	
    name_de: string;
    short_description_de: string;
	description_de: string;
	alias_de: string;
	
	created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/tastetype.ts